import { SimpleSelect } from "@repo/ui/Select/simpleSelect";
import { useEffect } from "react";
import { useAppSelector } from "../../hooks/hook.js";
import { selectAllPhoneNumbers } from "./phoneNumbersSlice.js";

interface PhoneNumberSelectorProps {
  phoneNumberId: string | undefined;
  onChange: (value: string) => void;
  className?: string;
}

export function PhoneNumberSelect({
  phoneNumberId,
  onChange,
  className,
}: PhoneNumberSelectorProps) {
  const phoneNumbers = useAppSelector(selectAllPhoneNumbers);
  const firstPhoneNumberId =
    phoneNumbers && phoneNumbers.length >= 2 ? phoneNumbers[0]?.id : undefined;

  // The selector visually defaults to the first phone number when no value is
  // set; sync that default into parent state so a form submission matches the
  // displayed selection.
  useEffect(() => {
    if (firstPhoneNumberId && phoneNumberId === undefined) {
      onChange(firstPhoneNumberId);
    }
  }, [firstPhoneNumberId, phoneNumberId, onChange]);

  // If we have less than 2 phone numbers, don't show the selector
  if (!phoneNumbers || phoneNumbers.length < 2) {
    return null;
  }

  const options = phoneNumbers.map((phoneNumber) => ({
    label: phoneNumber.number,
    value: phoneNumber.id,
  }));

  return (
    <div className={className}>
      <SimpleSelect
        options={options}
        label="Phone number"
        value={phoneNumberId ?? options[0]?.value ?? null}
        onChange={onChange}
        placeholder="Select a phone number"
      />
    </div>
  );
}
